module.exports = __webpack_public_path__ + "static/img/system.d9e76f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/system.png
// module id = z7xV
// module chunks = 3